import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import 'focus-options-polyfill';
import React, { useEffect } from 'react';
import { useOauth } from '@peloton/auth';
import { OauthProvider, useOauthEnabled } from '@webtv/auth';
import { API_ENVIRONMENT, toOauthEnv } from '@webtv/env';
import OfflineError from '@webtv/error-modal/OfflineError';
import { setGlobalContext, GlobalContext } from '@webtv/error-reporting-v2';
import { isExperimentEnabled } from '@webtv/feature-toggles';
import { OptimizelyFeature } from '@webtv/feature-toggles/featureToggles';
import useExperiments from '@webtv/feature-toggles/useExperiments';
import { PageShell, SWRConfigShell } from '@webtv/layout';
import { SplashPage } from '@webtv/onboarding';
import QAConfigTool from '@webtv/qa-config-tool';
import RootErrorBoundary from './setup/RootErrorBoundary';
import { HeadScripts, BootupEvents, WatchLastBrowseCategory, PersistedWatchTimeMetrics } from './';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var PageContainer = function PageContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(RootErrorBoundary, {
    children: /*#__PURE__*/_jsxs(SWRConfigShell, {
      children: [/*#__PURE__*/_jsx(HeadScripts, {}), children]
    })
  });
};

var BaseApp = function BaseApp(_ref2) {
  var Component = _ref2.Component,
      pageProps = _ref2.pageProps;
  var oauthEnabled = useOauthEnabled();
  var oauthEnv = toOauthEnv(API_ENVIRONMENT);
  return oauthEnabled ? /*#__PURE__*/_jsx(OauthProvider, {
    oauthEnv: oauthEnv,
    children: /*#__PURE__*/_jsx(AppContent, {
      Component: Component,
      pageProps: pageProps
    })
  }) : /*#__PURE__*/_jsx(AppContent, {
    Component: Component,
    pageProps: pageProps
  });
};

var AppContent = function AppContent(_ref3) {
  var Component = _ref3.Component,
      pageProps = _ref3.pageProps;
  var isExperimentsReady = useExperiments();
  var oauthEnabled = useOauthEnabled();

  var _useOauth = useOauth(),
      isLoading = _useOauth.isLoading;

  var isAuthReady = oauthEnabled ? oauthEnabled && !isLoading : true;
  useEffect(function () {
    if (isExperimentsReady) {
      // send optimizely enabled feature toggles to datadog
      var enabledFeatureToggles = Object.values(OptimizelyFeature).filter(isExperimentEnabled);
      setGlobalContext(GlobalContext.EnabledFeatureToggles, enabledFeatureToggles.join(', '));
    }
  }, [isExperimentsReady]);
  var canRender = isExperimentsReady && isAuthReady;
  return /*#__PURE__*/_jsxs(PageContainer, {
    children: [/*#__PURE__*/_jsx(BootupEvents, {}), /*#__PURE__*/_jsxs(PageShell, {
      children: [/*#__PURE__*/_jsx(OfflineError, {}), canRender ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(QAConfigTool, {}), /*#__PURE__*/_jsx(Component, _objectSpread({}, pageProps)), /*#__PURE__*/_jsx(WatchLastBrowseCategory, {}), /*#__PURE__*/_jsx(PersistedWatchTimeMetrics, {})]
      }) : /*#__PURE__*/_jsx(SplashPage, {})]
    })]
  });
};

export default BaseApp;